/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionVatReviewPendingCountData
 */
export interface SubscriptionVatReviewPendingCountData {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionVatReviewPendingCountData
     */
    count?: number;
}

/**
 * Check if a given object implements the SubscriptionVatReviewPendingCountData interface.
 */
export function instanceOfSubscriptionVatReviewPendingCountData(value: object): value is SubscriptionVatReviewPendingCountData {
    return true;
}

export function SubscriptionVatReviewPendingCountDataFromJSON(json: any): SubscriptionVatReviewPendingCountData {
    return SubscriptionVatReviewPendingCountDataFromJSONTyped(json, false);
}

export function SubscriptionVatReviewPendingCountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionVatReviewPendingCountData {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function SubscriptionVatReviewPendingCountDataToJSON(json: any): SubscriptionVatReviewPendingCountData {
    return SubscriptionVatReviewPendingCountDataToJSONTyped(json, false);
}

export function SubscriptionVatReviewPendingCountDataToJSONTyped(value?: SubscriptionVatReviewPendingCountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

